import React, { useReducer } from 'react';
import { DEFAULT_LOCALE } from '../../../../shared/constants';
import { onTranslateBtnClick } from '../../service/translations/ugcTranslations';
import { createBiData } from '../../config/ugcTranslations';
import { ALLOCATIONS, EXPERIMENTS } from '../../../../shared/constants/experiments';
import { reducer } from './reducer';

const AppContext = React.createContext();

const AppProvider = ({ children, knownCrawler, listings, appData, requestContext }) => {
    const {
        isTouch,
        context: {
            currency,
            sessionLocale,
            userId,
            sourceComponent,
            showLMBannerInSubCPage,
            isLMBannerInSearchAllowed,
            wordCount
        }
    } = listings[0];
    const { rollouts = {}, abTests = {}, flow, filter, pagination, sorting, user, assumedLanguage } = appData;
    const { categoryIds, significantLeafCategories, dominateSubCategoryId, query } = requestContext;

    const initialState = {
        user,
        isTouch,
        currency,
        showLMBannerInSubCPage,
        isLMBannerInSearchAllowed,
        sourceComponent,
        assumedLanguage,
        locale: sessionLocale,
        isDefaultLocale: sessionLocale === DEFAULT_LOCALE,
        knownCrawler,
        listings,
        filter,
        pagination,
        sorting,
        wordCount,
        categoryIds,
        significantLeafCategories,
        dominateSubCategoryId,
        query,
        loading: false,
        sourceInfo: createBiData({ userId, flow }),
        showTranslatedUGC: listings[0].showTranslatedUGC,
        wasTranslatedBefore: listings[0].showTranslatedUGC,
        onTranslateBtnClick,
        inUgcTranslationsRollout: rollouts.use_ugc_translations,
        searcherCrawlerBlocker: rollouts.searcher_crawler_blocker,
        isBusiness: rollouts.fiverr_business,
        inDiscountTest: abTests[EXPERIMENTS.SELLER_DISCOUNTS_TEST] === ALLOCATIONS.TEST_B,
        inNavigationTilesSCTest: abTests[EXPERIMENTS.CAT_LISTINGS_SC_FILTER_TILES] === ALLOCATIONS.TEST_B,
        inSearchNavigationTiles: abTests[EXPERIMENTS.CAT_LISTINGS_SEARCH_FILTER_TILES] === ALLOCATIONS.TEST_B,
        inNscIconsMobileWeb: abTests[EXPERIMENTS.CAT_LISTINGS_NSC_ICONS_MOBILE_WEB] === ALLOCATIONS.TEST_B,
        inLogoDesignDiscountTest: abTests[EXPERIMENTS.SELLER_DISCOUNTS_TEST_LOGO_DESIGN] === ALLOCATIONS.TEST_B
    };

    const [appState, dispatch] = useReducer(reducer, initialState);

    return (
        <AppContext.Provider value={{ ...appState, dispatch }}>
            {children}
        </AppContext.Provider>
    );};

export {
    AppProvider,
    AppContext
};
